module.exports = __webpack_public_path__ + "img/Črna gora.7992d045.png";